import leftArrow from 'assets/icons/leftArrow.svg';
import rightArrow from 'assets/icons/rightArrow.svg';
import { drugStatusInterface } from 'Interfaces/FactsInterfaces/DrugPortfolioInterface';
import { observer } from 'mobx-react';
import 'primeicons/primeicons.css';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useState } from 'react';
import classes from './ndclist.module.scss';
import { useNDCListComponent } from './useNDCListComponent';

const NDCListSection = ({
  heading,
  ndcs,
  from,
  dest,
}: {
  heading: string;
  ndcs: drugStatusInterface[];
  from: string;
  dest: string;
}) => {
  const {
    op,
    gfcToggleClicked,
    handleToggleClick,
    handleUpdate,
    handleGFCUpdate,
    handleGFCtoggleClick,
  } = useNDCListComponent();
  const [filteredData, setFilteredData] = useState(ndcs);
  const [searchNDC, setSearchNDC] = useState<string>('');
  const [rerenderTrigger, setRerenderTrigger] = useState<number>(0);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  useEffect(() => {
    if (ndcs) {
      const filtered: drugStatusInterface[] = [];
      for (let i = 0; i < ndcs.length; i++) {
        const conceptMatch = ndcs[i].Concept
          ? ndcs[i].Concept.toLowerCase().includes(searchNDC.toLowerCase())
          : false; // Handle null concept values
        const ndcMatch = ndcs[i].NDC11_list.some(item =>
          item.NDC11.toLowerCase().includes(searchNDC.toLowerCase())
        );
        if (conceptMatch || ndcMatch) {
          filtered.push(ndcs[i]);
        }

        // break if length reached to 30
        if (filtered.length > 100) break;
      }
      // const filtered = ndcs.filter((row) => {
      //   idx++;
      //   if (idx > 30) {

      //   }
      //   const conceptMatch = row.Concept
      //     ? row.Concept.toLowerCase().includes(searchNDC.toLowerCase())
      //     : false; // Handle null concept values
      //   const ndcMatch = row.NDC11_list.some((item) =>
      //     item.NDC11.toLowerCase().includes(searchNDC.toLowerCase())
      //   );
      //   return conceptMatch || ndcMatch;
      // });
      setFilteredData(filtered);
      setRerenderTrigger(rerenderTrigger + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ndcs, searchNDC]);

  const handleSearch = (e: any) => {
    e.preventDefault();
    setSearchNDC(e.target.value);
  };

  return (
    <div className={classes.listBtnContainer}>
      <div className={classes.headingContainer}>
        <h4>{heading}</h4>
        <div className={classes.searchContainer}>
          <span className={classes.searchIconContainer}>
            <i className="pi pi-search"></i>
          </span>
          <InputText
            style={{ width: '20rem', border: 'none', outline: 'none', boxShadow: 'none' }}
            value={searchNDC}
            onChange={handleSearch}
            placeholder="Search by drug name or NDC..."
            className={classes.searchInput}
          />
        </div>
        <div style={{ height: '69vh', overflowY: 'scroll' }}>
          {filteredData &&
            filteredData.map((row, idx) => {
              const isExpanded = expandedIndex === idx;
              return (
                <div className={classes.row} key={row.GFC}>
                  <div className={classes.customAccordion}>
                    <div
                      className={classes.accordionHeader}
                      onClick={() => setExpandedIndex(isExpanded ? null : idx)}
                    >
                      <span className={classes.accordionTitle}>{row.Concept}</span>
                      <div className={classes.accordionActions}>
                        {heading !== 'Inactive' && (
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              handleGFCtoggleClick(e, row.GFC);
                            }}
                            className={classes.moveIcon}
                          >
                            {heading === 'Active' ? (
                              <i className="pi pi-angle-right" />
                            ) : (
                              <i className="pi pi-angle-left" />
                            )}
                          </span>
                        )}
                        <i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} />
                      </div>
                    </div>
                    {isExpanded && (
                      <div className={classes.accordionContent}>
                        {row.NDC11_list.map((item, i) => {
                          return (
                            <div key={i} className={classes.ndcItem}>
                              <p className={classes.ndcText}>{item.NDC11}</p>
                              {item.loading && (
                                <ProgressSpinner style={{ width: '25px', height: '25px' }} />
                              )}
                              {heading !== 'Inactive' && (
                                <span
                                  onClick={e =>
                                    handleToggleClick(e, item.Component_ID, row.GFC, item.NDC11)
                                  }
                                  className={classes.ndcMoveIcon}
                                >
                                  {!item.loading && (
                                    <>
                                      {heading === 'Active' ? (
                                        <img src={rightArrow} alt="arrow" />
                                      ) : (
                                        <img src={leftArrow} alt="arrow" />
                                      )}
                                    </>
                                  )}
                                </span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      <div>
        <OverlayPanel ref={op} className={classes.popupComponent}>
          <div
            style={{
              margin: '-1rem',
            }}
          >
            <p
              style={{
                width: '6rem',
                textAlign: 'center',
                cursor: 'pointer',
                fontWeight: '600',
                color: '#522d6e',
              }}
              onClick={e =>
                !gfcToggleClicked ? handleUpdate(e, from, dest) : handleGFCUpdate(e, from, dest)
              }
            >
              {dest}
            </p>
          </div>
        </OverlayPanel>
      </div>
    </div>
  );
};

export default observer(NDCListSection);
